export default __webpack_public_path__ + "static/media/file-outline.713eec85.png";